const loadCSS = ({ targetElement, href, id, onLinkLoad }) => {
  const document = window.document
  if (document.querySelector(`#${id}`) === null) {
    let linkTag = document.createElement("link")
    linkTag.id = id
    linkTag.media = "print"
    linkTag.rel = "stylesheet"
    linkTag.href = href
    targetElement.appendChild(linkTag)
    linkTag.onload = () => {
      linkTag.media = "all"
      onLinkLoad && onLinkLoad()
    }
  }
}

export default loadCSS
